const runtimeHost = typeof window !== 'undefined'
    ? String(window.location.hostname || '').toLowerCase()
    : '';

const runtimeAdminOrigin = typeof window !== 'undefined' && runtimeHost.startsWith('admin.')
    ? window.location.origin
    : '';

export const ADMIN_API_BASE = String(
    process.env.REACT_APP_ADMIN_API_BASE_URL
    || process.env.REACT_APP_API_BASE_URL
    || runtimeAdminOrigin
    || 'https://api.xn--omrdeskollen-vcb.nu',
).replace(/\/+$/, '');

export const ADMIN_LOGIN_ENDPOINT = String(
    process.env.REACT_APP_ADMIN_LOGIN_ENDPOINT
    || process.env.REACT_APP_LOGIN_ENDPOINT
    || `${ADMIN_API_BASE}/auth/password-login`,
).trim();

export const ADMIN_LOGIN_FALLBACK_ENDPOINT = String(
    process.env.REACT_APP_ADMIN_LOGIN_FALLBACK_ENDPOINT
    || `${ADMIN_API_BASE}/auth/login`,
).trim();

const ADMIN_SESSION_FLAG_KEY = 'admin_authenticated';
const ADMIN_TOKEN_STORAGE_KEYS = ['admin_job_token', 'admin_token', 'access_token', 'token'];

const stripBearerPrefix = (rawToken) => String(rawToken || '').trim().replace(/^bearer\s+/i, '').trim();

const readTokenFromStorage = () => {
    if (typeof window === 'undefined') return '';
    for (const key of ADMIN_TOKEN_STORAGE_KEYS) {
        const localValue = window.localStorage?.getItem(key);
        if (localValue && String(localValue).trim()) return String(localValue).trim();
        const sessionValue = window.sessionStorage?.getItem(key);
        if (sessionValue && String(sessionValue).trim()) return String(sessionValue).trim();
    }
    return '';
};

export const hasAdminSession = () => {
    if (typeof window === 'undefined') return false;
    if (window.sessionStorage?.getItem(ADMIN_SESSION_FLAG_KEY) === '1') return true;
    return Boolean(readTokenFromStorage());
};

// Set when an admin login came back without the API's token (a backend older than the token hand-out, or one
// with no ADMIN_API_TOKEN): a 401 after it then says so instead of "session ended".
const ADMIN_NO_TOKEN_KEY = 'admin_login_without_token';

export const loginCameWithoutToken = () => {
    try {
        return window.sessionStorage?.getItem(ADMIN_NO_TOKEN_KEY) === '1';
    } catch (error) {
        return false;
    }
};

export const persistAdminSession = (token) => {
    if (typeof window === 'undefined') return;
    window.sessionStorage?.setItem(ADMIN_SESSION_FLAG_KEY, '1');

    const normalizedToken = stripBearerPrefix(token);
    if (!normalizedToken) {
        window.sessionStorage?.setItem(ADMIN_NO_TOKEN_KEY, '1');
        return;
    }
    window.sessionStorage?.removeItem(ADMIN_NO_TOKEN_KEY);

    window.localStorage?.setItem('admin_token', normalizedToken);
    window.sessionStorage?.setItem('admin_token', normalizedToken);
    window.localStorage?.setItem('admin_job_token', normalizedToken);
    window.sessionStorage?.setItem('admin_job_token', normalizedToken);
};

// A request the API refused (401: no token, or a token that has since changed) ends the session; the gate
// (AdminGatePage.js) then shows the login again.
export const ADMIN_SESSION_ENDED_EVENT = 'admin-session-ended';

export const endAdminSession = () => {
    clearAdminSession();
    if (typeof window !== 'undefined') window.dispatchEvent(new Event(ADMIN_SESSION_ENDED_EVENT));
};

export const clearAdminSession = () => {
    if (typeof window === 'undefined') return;
    window.sessionStorage?.removeItem(ADMIN_SESSION_FLAG_KEY);
    for (const key of ADMIN_TOKEN_STORAGE_KEYS) {
        window.localStorage?.removeItem(key);
        window.sessionStorage?.removeItem(key);
    }
};
